import { useContext } from 'react';

import DateFormatterContext from '../DateFormatterContext';
import { IDateFormatterContext, IUseDateFormat } from '../interfaces';
import { format } from '../utils/format';
import { toDate } from '../utils/transform';

export const useDateFormat = (options: IUseDateFormat = {}) => {
  const context = useContext<IDateFormatterContext>(DateFormatterContext);

  const {
    timeZone = 'utc',
    template = context.template,
    empty = context.empty,
    locale = context.locale,
  } = options ?? {};

  return (
    value: string | Array<string> | undefined,
    templateLocal: string = template
  ) => {
    return format({
      value: toDate(value),
      timeZone,
      locale,
      template: templateLocal,
      empty,
    });
  };
};
